import { useQuery } from "@tanstack/react-query";
import panelApi from "@/lib/panelApi";

// Valores manuais por colaborador + quinzena + componente: { "q|user_id|item_id": valor }.
export const useCompOverrides = (month) =>
  useQuery({ queryKey: ["comp-overrides", month], queryFn: async () => (await panelApi.get("/panel/comp-overrides", { params: { month } })).data?.overrides || {} });

export const ovKey = (q, uid, itemId) => `${q}|${uid}|${itemId}`;
